import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../../utils/axiosBaseQuery';
import { DepotLocation, DepotLocationPayload } from '../../types/locations';
import { Group } from '../types';
import { serializeQueryArgsWithTenant } from '../tenantCacheKey';

export interface UpdateDepotStatus {
    status: {
        enabled: boolean;
        bookable: boolean;
    };
}

export const locationsApiSlice = createApi({
    reducerPath: 'locationsApiSlice',
    serializeQueryArgs: serializeQueryArgsWithTenant,
    baseQuery: axiosBaseQuery(),
    tagTypes: ['locationList', 'Groups'],
    endpoints: (builder) => ({
        getLocationList: builder.query<DepotLocation[], string | undefined>({
            query: (queryParam) => {
                return {
                    url: queryParam ? `/location?services=${queryParam}` : '/location',
                };
            },
            providesTags: ['locationList'],
        }),
        fetchDepotLocations: builder.query<DepotLocationPayload, void>({
            query: () => ({
                url: 'location?includeDisabled=true',
                method: 'GET',
            }),
        }),
        updateDepotStatus: builder.mutation<void, { data: UpdateDepotStatus, locationId: string }>({
            query: ({ data, locationId }) => ({
                url: `/location/${locationId}/state`,
                method: 'POST',
                data,
            }),
        }),
        getGroupsWithPrices: builder.query<Group[], string>({
            query: (locationId) => ({
                url: `/location/${locationId}/groups/include-price`,
                method: 'GET',
            }),
            providesTags: (result, error, locationId) => [
                { type: 'Groups', id: locationId },
            ],
        }),
    }),
});

export const { 
    useGetLocationListQuery, 
    useFetchDepotLocationsQuery, 
    useUpdateDepotStatusMutation,
    useGetGroupsWithPricesQuery,
} = locationsApiSlice;
